<template>
  <div class="section col_w_3 service_info_section">
    <div class="section_wrap">
      <h6 class="--blue70 mb20">{{ $t('my.payment.serviceInfo.title') }}</h6>
      <div class="option_container">
        <div>
          <p class="txt_subtitle_1 mb10">
            {{ $t('my.payment.serviceInfo.my_service') }}
          </p>
          <div class="option_my_service">
            <p class="txt_body_1 mr10">
              {{ currentSubscriptionInfoProps.defaultProductTitle }} ({{ currentSubscriptionInfoProps.defaultProductSubTitle }})
            </p>
            <a
                @click="$modal.show('change-service-plan-modal', currentSubscriptionInfoProps)"
                class="small-line-button-blue70"
            >
              Change
            </a>
            <span class="txt_divider">|</span>
            <p class="txt_body_1 mr10">
              Billed {{ computedPaymentType(currentSubscriptionInfoProps.paymentType) }}
              ({{ paymentInfoProps.cardType }}{{ paymentInfoProps.maskedCardNumber }})
            </p>
            <a
                @click="$modal.show('change-payment-info-modal', {
                  currentSubscriptionInfoProps,
                  paymentInfoProps
                })"
                class="small-line-button-blue70"
            >
              Change
            </a>
          </div>
        </div>
      </div>
      <div
          v-if="currentSubscriptionInfoProps.seqProduct !== nextSubscriptionInfoProps.seqProduct ||
          currentSubscriptionInfoProps.paymentType !== nextSubscriptionInfoProps.paymentType"
          class="option_container"
      >
        <div>
          <p class="txt_subtitle_1 mb10">
            {{ $t('my.payment.serviceInfo.next_service') }}
          </p>
          <div class="option_my_service">
            <p class="txt_body_1">
              {{ nextSubscriptionInfoProps.defaultProductTitle }} ({{ nextSubscriptionInfoProps.defaultProductSubTitle }})
            </p>
            <span class="txt_divider">|</span>
            <p class="txt_body_1">
              Billed {{ computedPaymentType(nextSubscriptionInfoProps.paymentType) }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <ChangeServicePlanModal @getMyPurchaseSummaryFromServer="getMyPurchaseSummaryFromServer"/>
    <ChangePaymentInfoModal @getMyPurchaseSummaryFromServer="getMyPurchaseSummaryFromServer"/>
  </div>
</template>
<script>
import ChangeServicePlanModal from "@/components/modal/payments/changeServicePlanModal";
import ChangePaymentInfoModal from "@/components/modal/payments/changePaymentInfoModal";

export default {
  name: 'ServiceInformation',
  props: {
    paymentInfoProps: Object,
    currentSubscriptionInfoProps: Object,
    nextSubscriptionInfoProps: Object,
  },
  components: {
    ChangeServicePlanModal,
    ChangePaymentInfoModal
  },
  computed: {
    computedPaymentType() {
      return (paymentType) => {
        let type = '';
        switch (paymentType) {
          case 2:
            type = 'Monthly';
            break;
          case 3:
            type = 'Yearly';
            break;
          default:
            type = 'Error'
            break;
        }
        return type
      }
    }
  },
  methods: {
    getMyPurchaseSummaryFromServer() {
      this.$emit('getMyPurchaseSummaryFromServer');
    }
  }
}

</script>
<style lang="scss">

.service_info_section {
  .option_container {
    display: flex;
    justify-content: space-between;
  }
}

</style>